// extracted by mini-css-extract-plugin
module.exports = {"button":"ThemeToggler_button__2_aGr"};